import { constantRouterMap } from '@/router'

let lodash = require('lodash')
const permission = {
  state: {
    routers: constantRouterMap
  },
  mutations: {
    asyncFilterPermission (state, permission) {
      for (let v in state.routers) {
        if (lodash.indexOf(permission, state.routers[v].name) === -1 && !state.routers[v].hidden) {
          state.routers[v].hidden = true
        }
      }
    }
  }
}

export default permission



// WEBPACK FOOTER //
// ./src/store/permission.js